/**
 * Shared field-name conventions for mobile-service artifacts.
 *
 * mobile-service names every artifact's own primary key ``mobileArtifactId`` and
 * its owning-acquisition foreign key ``mobileAcquisitionId``. These names are
 * referenced from query builders, column resolution, threading, and the map
 * hooks, so they live here as single-source constants rather than repeated
 * string literals. A backend rename becomes a one-line change.
 */

/** Artifact primary key: stable per-row id used as a React key and query filter. */
export const ARTIFACT_ID_FIELD = 'mobileArtifactId';

/** Owning-acquisition foreign key present on every artifact row. */
export const ACQUISITION_ID_FIELD = 'mobileAcquisitionId';

/**
 * Separator joining the parts of a composite (multi-field) thread key.
 *
 * A control character (U+0001, Start of Heading) is used deliberately so it can
 * never collide with real field values. The writer ({@link resolveThreadKey})
 * and any reader that splits a composite key back into parts must share this.
 */
export const COMPOSITE_THREAD_KEY_SEPARATOR = '\u0001';
